import { http } from "../../services";

export const onLogout: producer = async ({
    jwtToken = get.jwtToken,
    updateJwtToken = update.jwtToken,
    loggedout = observe.loggedOut,
    isAuthenticated = update.views[prop._viewId].data.isAuthenticated,
    error = update.views[prop._viewId].data.error,
    envelopes = update.envelopes,
}) => {
    if(!loggedout){
        return;
    }

    try {
        await http({
            method: "DELETE",
            url: `/api/authorizer/token`,
            headers: {
                "Authorization": `Bearer ${jwtToken.value()}`
            }
        });
        
        logout(envelopes, updateJwtToken, isAuthenticated);
    } catch (e: any) {
        logout(envelopes, updateJwtToken, isAuthenticated);
        console.log(e);
        error.set(e.message);
    }
};

function logout(envelopes: any, updateJwtToken: any, isAuthenticated: any) {
    window.sessionStorage.removeItem('accessToken');
    envelopes.remove();
    updateJwtToken.remove();
    isAuthenticated.set(false);
    window.history.pushState("", "", "#!/login");
    window.location.reload();
    console.log("Logged out.");
}